import { render } from "./TalkToMyDataInvocationAdmin.vue?vue&type=template&id=773a0015&scoped=true"
import script from "./TalkToMyDataInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocationAdmin.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocationAdmin.vue?vue&type=style&index=0&id=773a0015&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773a0015"]])

export default __exports__